import { useMemo } from 'react';

const useLocalTimezone = () => {
  const timezone = useMemo(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    [],
  );
  return timezone;
};

export default useLocalTimezone;
